import Home from '../views/home';
import Login from '../views/login';
import Sales from '../views/sales';
import NotFound from '../views/404';
import Profile from '../views/profile';
import Financial from '../views/financial';
import TankerFailure from '../views/tanker_failure';
import IncentivePlan from '../views/incentive_plan';
import ChangePassword from '../views/change_password';
import RefuelingTanker from '../views/refueling_tanker';
import RefuelTanker from '../views/refuel_tanker';
import TankerFailureList from '../views/tanker_failure/list';
import SalesLocal from '../views/fuel_request_list/complete/local';
import SalesOnline from '../views/fuel_request_list/complete/online';
import CommunicationManagement from '../views/communication_management';
import FuelRequestOnlineInprocess from '../views/fuel_request_inprocess/online';
import SalesOrganization from '../views/fuel_request_list/complete/organization';
import FuelRequestOrganizationInprocess from '../views/fuel_request_inprocess/organization';

////////////////////////////////////////////////////////////////////

export const HOME = '/';
export const NOT_FOUND = '*';
export const LOGIN = '/login';
export const SALES = '/sales';
export const PROFILE = '/profile';
export const FINANCIAL = '/financial';
export const SALES_LOCAL = '/sales-local';
export const SALES_ONLINE = '/sales-online';
export const TANKER_FAILURE = '/tanker-failure';
export const INCENTIVE_PLAN = '/incentive-plan';
export const REFUEL_TANKER = '/refuel-tanker';
export const COMMUNICATION_MANAGER = '/communication-management';
export const CHANGE_PASSWORD = '/change-password';
export const REFUELING_TANKER = '/refueling-tanker';
export const SALES_ORGANIZATION = '/sales-organization';
export const TANKER_FAILURE_LIST = '/tanker-failure-list';
export const FUEL_REQUEST_ONLINE_INPROCESS = '/fuel-request-online-inprocess/:id';
export const FUEL_REQUEST_ORGANIZATION_INPROCESS =
  '/fuel-request-organization-inprocess/:id';

////////////////////////////////////////////////////////////////////

const routerList = [
  { router: HOME, page: <Home /> },
  { router: LOGIN, page: <Login /> },
  { router: SALES, page: <Sales /> },
  { router: PROFILE, page: <Profile /> },
  { router: FINANCIAL, page: <Financial /> },
  { router: SALES_LOCAL, page: <SalesLocal /> },
  { router: SALES_ONLINE, page: <SalesOnline /> },
  { router: TANKER_FAILURE, page: <TankerFailure /> },
  { router: INCENTIVE_PLAN, page: <IncentivePlan /> },
  { router: CHANGE_PASSWORD, page: <ChangePassword /> },
  { router: REFUELING_TANKER, page: <RefuelingTanker /> },
  { router: REFUEL_TANKER, page: <RefuelTanker /> },
  { router: SALES_ORGANIZATION, page: <SalesOrganization /> },
  { router: TANKER_FAILURE_LIST, page: <TankerFailureList /> },
  { router: COMMUNICATION_MANAGER, page: <CommunicationManagement /> },
  { router: FUEL_REQUEST_ONLINE_INPROCESS, page: <FuelRequestOnlineInprocess /> },
  {
    router: FUEL_REQUEST_ORGANIZATION_INPROCESS,
    page: <FuelRequestOrganizationInprocess />,
  },
  { router: NOT_FOUND, page: <NotFound /> },
];

const routerListLogin = [
  {
    router: LOGIN,
    page: <Login />,
  },
  {
    router: NOT_FOUND,
    page: <NotFound />,
  },
];

export { routerList, routerListLogin };
